import CodeBase from "./CodeBase.js"

// 시나리오 답변 유형

class AnswerType extends CodeBase {
  constructor() {
    const CODE_MAP = {
      'A' : '객관식',
      'B' : '주관식',
      'C' : 'Y/N',
      'D' : 'n점 척도',
      'E' : 'N/A'
    };

    super(CODE_MAP);
  }
}

export default AnswerType;
